export const csHelp = {
  intro: {
    title: "Nápověda",
  },
  cheatSheet: {
    title: "Tahák",
    t1: 'Tento "tahák" popisuje všechny interakce myši či klávesnice.',
    interactions: {
      Plátno: {
        "Posouvat plátno:": "Táhněte levým tlačítkem myši",
        "Přibližovat/oddalovat v plátně:": "Použijte kolečko myši",
      },
      Pojmy: {
        "Vytvořit pojem:": "Klikněte pravým tlačítkem myši na plátno",
        "Najít pojem na plátně (pokud na něm je):":
          "Klikněte na pojem v levém panelu",
        "Přesunout existující/schovaný pojem na plátno:":
          "Přetáhněte pojem levým tlačítkem myši z levého panelu na plátno",
        "Přesunout existující/schované pojmy na plátno:":
          "Ctrl + levé tlačítko myši, poté přetáhněte z levého panelu na plátno",
        "Vybrat/editovat/zobrazit detaily pojmu:":
          "Klikněte na pojem v levém panelu nebo na plátně",
        "Vybrat pojmy:":
          "Ctrl + levé tlačítko myši na každý pojem v levém panelu či na plátně / Podržte Shift + levé tlačítko myši a táhněte na plátně",
        "Vybrat všechny pojmy na plátně:": "Ctrl + A",
        "Přesunout pojem:": "Přetáhněte pojem levým tlačíkem myši",
        "Přesunout pojmy:":
          "Přetáhněte jeden z vybraných pojmů levým tlačíkem myši",
        "Schovat pojem:":
          "Přesuňte myš na pojem na plátně + klikněte na škrtlé oko",
        "Schovat vybrané pojmy:": "Delete",
        "Smazat pojem:":
          "Přesuňte myš na pojem v levém panelu + klikněte na ❌",
      },
      Vztahy: {
        "Vytvořit vztah":
          "Přesuňte myš na pojem na plátně + klikněte na šipku. Klikněte na další pojem na plátně a vyberte vztah",
        "Vybrat/editovat/zobrazit detaily vztahu:": "Klikněte na vztah",
        "Vybrat/zrušit výběr více vztahů:":
          "Ctrl + levé tlačítko myši na vztah",
        "Smazat vztah:": "Přesuňte myš na vybraný pojem + klikněte na ❌",
        "Vytvořit vrchol ve vztahu:": "Klikněte na vybraný pojem",
        "Smazat vrchol ve vztahu:":
          "Přetáhněte bod ve vybraném pojmu levým tlačítkem myši",
      },
      Diagramy: {
        "Vytvořit diagram:": "Klikněte na kartu ➕ vedle všech ostatních karet",
        "Vybrat diagram:": "Klikněte na kartu diagramu",
        "Přejmenovat diagram:": "Klikněte na jméno vybraného diagramu",
        "Smazat diagram:": "Klikněte na ❌ na vybraném diagramu",
      },
    },
  },
};
